import { defineMessages } from 'react-intl';
export default defineMessages({
	defaultKanbanProjectName: {
		id: 'sample-project.utils.default-kanban-project-name',
		defaultMessage: 'My Kanban Project',
		description: 'The default name of the kanban project',
	},
	defaultScrumProjectName: {
		id: 'sample-project.utils.default-scrum-project-name',
		defaultMessage: 'My Scrum Project',
		description: 'The default name of the scrum project',
	},
	featureIssueTypeName: {
		id: 'sample-project.utils.feature-issue-type-name',
		defaultMessage: 'Feature',
		description: 'The name of the feature issue type',
	},
	taskIssueTypeName: {
		id: 'sample-project.utils.task-issue-type-name',
		defaultMessage: 'Task',
		description: 'The name of the task issue type',
	},
	storyIssueTypeName: {
		id: 'sample-project.utils.story-issue-type-name',
		defaultMessage: 'Story',
		description: 'The name of the story issue type',
	},
	bugIssueTypeName: {
		id: 'sample-project.utils.bug-issue-type-name',
		defaultMessage: 'Bug',
		description: 'The name of the bug issue type',
	},
	assetIssueTypeName: {
		id: 'sample-project.utils.asset-issue-type-name',
		defaultMessage: 'Asset',
		description: 'The name of the asset issue type',
	},
	contactIssueTypeName: {
		id: 'sample-project.utils.contact-issue-type-name',
		defaultMessage: 'Contact',
		description: 'The name of the contact issue type',
	},
	requestIssueTypeName: {
		id: 'sample-project.utils.request-issue-type-name',
		defaultMessage: 'Request',
		description: 'The name of the request issue type',
	},
	researchItemIssueTypeName: {
		id: 'sample-project.utils.research-item-issue-type-name',
		defaultMessage: 'ResearchItem',
		description: 'The name of the research item issue type',
	},
	incidentIssueTypeName: {
		id: 'sample-project.utils.incident-issue-type-name',
		defaultMessage: 'Incident',
		description: 'The name of the incident item issue type',
	},
	serviceRequestIssueTypeName: {
		id: 'sample-project.utils.service-request-issue-type-name',
		defaultMessage: 'ServiceRequest',
		description: 'The name of the service request issue type',
	},
	supportIssueTypeName: {
		id: 'sample-project.utils.support-issue-type-name',
		defaultMessage: 'Support',
		description: 'The name of the support issue type',
	},
	campaignIssueTypeName: {
		id: 'sample-project.utils.campaign-issue-type-name',
		defaultMessage: 'Campaign',
		description: 'The name of the support issue type',
	},
	candidateIssueTypeName: {
		id: 'sample-project.utils.candidate-issue-type-name',
		defaultMessage: 'Candidate',
		description: 'The name of the candidate issue type',
	},
	ideaColumnName: {
		id: 'sample-project.utils.idea-column-name',
		defaultMessage: 'Idea',
		description: 'Idea column name',
	},
	todoColumnName: {
		id: 'sample-project.utils.todo-column-name',
		defaultMessage: 'To Do',
		description: 'To Do column name',
	},
	inProgressColumnName: {
		id: 'sample-project.utils.in-progress-column-name',
		defaultMessage: 'In Progress',
		description: 'In Progress column name',
	},
	inReviewColumnName: {
		id: 'sample-project.utils.in-review-column-name',
		defaultMessage: 'In Review',
		description: 'In Review column name',
	},
	doneColumnName: {
		id: 'sample-project.utils.done-column-name',
		defaultMessage: 'Done',
		description: 'Done column name',
	},
	testingColumnName: {
		id: 'sample-project.utils.testing-column-name',
		defaultMessage: 'Testing',
		description: 'Testing column name',
	},
	inDesignColumnName: {
		id: 'sample-project.utils.in-design-column-name',
		defaultMessage: 'In Design',
		description: 'In Design column name',
	},
	userTestingColumnName: {
		id: 'sample-project.utils.user-testing-column-name',
		defaultMessage: 'User Testing',
		description: 'User Testing column name',
	},
	approvedColumnName: {
		id: 'sample-project.utils.approved-column-name',
		defaultMessage: 'Approved',
		description: 'Approved column name',
	},
	liveColumnName: {
		id: 'sample-project.utils.live-column-name',
		defaultMessage: 'Live',
		description: 'Live column name',
	},
	waitingForCustomerColumnName: {
		id: 'sample-project.utils.waiting-for-customer-column-name',
		defaultMessage: 'Waiting for Customer',
		description: 'Waiting for customer column name',
	},
	resolvedColumnName: {
		id: 'sample-project.utils.resolved-column-name',
		defaultMessage: 'Resolved',
		description: 'Resolved column name',
	},
});
